// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1275":"e527e5ae976e5785","2888":"c33d1c57a1c0d06e"}[chunkId] + ".css";
};